import MaterialTable from "material-table";
import TableIcons from "../../utils/TableIcons";
import {Autocomplete} from "@material-ui/lab";
import {Button, Grid, TextField, Typography} from "@material-ui/core";
import RenderInput from "../TrafficSource/RenderInput";
import _ from "lodash";
import RefreshIcon from "@material-ui/icons/Refresh";
import DeleteIcon from "@material-ui/icons/Delete";
import React, {memo} from "react";
import useStyles from "../../styles/styles";
import getEnvironment from "../../utils/getEnvironment";
import setDatePst from "../../utils/setDatePst";
import theme from "../../styles/theme";
import WarningIcon from "@material-ui/icons/Warning";


const VendorPauseTable = memo(({
                                   data,
                                   tableRef,
                                   selectedRows,
                                   sortedServicers,
                                   createVendorPause,
                                   updateVendorPause,
                                   deleteVendorPause,
                                   refetch,
                                   onSelectionChange,
                                   handleKey,
                                   handleClickConfirmationOpen
                               }) => {
    const classes = useStyles();
    const env = getEnvironment();

    const hasServicer = obj => _.has(obj, 'servicer');
    const returnOptions = (val, type) => {
        const hasType = _.has(val, type);
        if (hasType) {
            return val[type];
        }

        const arr = sortedServicers.filter(item => item.servicer === val);
        if (arr.length) {
            return arr[0][type];
        }

        return [];
    };

    const TimezoneBanner = () => {
        return (
            <div style={{backgroundColor: theme.palette.warning.main}} className={classes.banner}>
                <WarningIcon style={{fontSize: '200%', marginRight: theme.spacing(1)}}/>
                <Typography background={"secondary"} variant="h4" component="h4"
                            className={classes.monospace + " " + classes.blockSignature} id={"page-top"}
                > All dates/times must be entered in PST </Typography>
                <WarningIcon style={{fontSize: '200%', marginLeft: theme.spacing(1)}}/>
            </div>
        )
    }

    const columns = [
        {title: 'Id', field: "id", hidden: true},
        {
            title: "Servicer", field: "servicer", editable: "onAdd",
            editComponent: props => (
                <Autocomplete
                    size="medium"
                    freeSolo
                    autoSelect
                    className={classes.autoComplete}
                    value={props.value || null}
                    onChange={(event, value) => {
                        props.onChange(value);
                    }}
                    getOptionLabel={option => {
                        if (hasServicer(option)) {
                            return option.servicer;
                        }
                        return option;
                    }}
                    options={sortedServicers}
                    onKeyDown={e => handleKey(e)}
                    renderInput={params => <TextField {...params} label="Servicer" fullWidth
                                                      error={props.value === ''}/>}
                />
            )
        },
        {
            title: "Portfolio", field: "portfolio", editable: "onAdd",
            editComponent: props => {
                const {servicer} = props.rowData;
                const portfolios = returnOptions(servicer, 'portfolio');
                return (
                    <Autocomplete
                        size="medium"
                        freeSolo
                        autoSelect
                        className={classes.autoComplete}
                        value={props.value || null}
                        onChange={(event, value) => {
                            props.onChange(value);
                        }}
                        disabled={!!props.rowData.campaign || !props.rowData.servicer}
                        getOptionLabel={option => option}
                        options={portfolios}
                        onKeyDown={e => handleKey(e)}
                        renderInput={params => <TextField {...params} label="Portfolio" fullWidth
                                                          error={props.value === ''}/>}
                    />
                )
            }
        },
        {
            title: "Campaign", field: "campaign", editable: "onAdd",
            editComponent: props => {
                const {servicer} = props.rowData;
                const campaigns = returnOptions(servicer, 'campaigns');
                return (
                    <Autocomplete
                        size="medium"
                        freeSolo
                        openOnFocus
                        autoSelect
                        className={classes.autoComplete}
                        value={props.value || null}
                        onChange={(event, value) => {
                            props.onChange(value);
                        }}
                        disabled={!!props.rowData.portfolio || !props.rowData.servicer}
                        getOptionLabel={option => option}
                        options={campaigns}
                        onKeyDown={e => handleKey(e)}
                        renderInput={params => <TextField {...params} label="Campaign" fullWidth
                                                          error={props.value === ''}/>}
                    />
                );
            }
        },
        {
            title: "Start Date (PST)", field: "startDate",
            editComponent: props => (
                <RenderInput
                    item={{
                        label: '',
                        type: 'dateTimeLocal',
                        key: 'startDate',
                        required: false
                    }}
                    value={props.value}
                    data={data}
                    style={{marginTop: '16px'}}
                    handleFilterChange={(value) => {
                        props.onChange(value);
                    }}
                />
            )
        },
        {
            title: "Expiration (PST)", field: "expiration",
            editComponent: props => (
                <RenderInput
                    item={{
                        label: '',
                        type: 'dateTimeLocal',
                        key: 'expiration',
                        required: false
                    }}
                    value={props.value}
                    data={data}
                    style={{marginTop: '16px'}}
                    handleFilterChange={(value) => {
                        props.onChange(value);
                    }}
                />
            )
        },
        {title: "Pause Source", field: "pauseSource"},
    ]

    const getChecked = (id) => {
        const row = selectedRows.find(element => element.id === id)
        if (row) {
            return true
        }

        return false
    }

    const DeleteButton = ({checkedRows}) => {
        return (
            <Grid container direction="row" justify="space-between" alignItems="center" style={{marginBottom: '15px'}}>
                <Grid item xs={4}>
                </Grid>
                <Grid item xs={4} style={{textAlign: 'right'}}>
                    <Button
                        variant="contained"
                        color="primary"
                        onClick={() => handleClickConfirmationOpen()}
                        startIcon={<DeleteIcon/>}
                        // disabled={checkedRows.length === 0}
                    >
                        DELETE SELECTED
                    </Button>
                    )
                </Grid>
            </Grid>
        )
    }

    return (
        <>
            <DeleteButton
                checkedRows={tableRef.current ? tableRef.current.dataManager.data.filter(o => o.tableData.checked) : []}/>
            <TimezoneBanner/>
            <MaterialTable
                title=""
                tableRef={tableRef}
                icons={TableIcons}
                columns={columns}
                data={data.allVendorPause.nodes.map(VendorPause => ({
                    checked: VendorPause.checked,
                    id: VendorPause.id,
                    campaign: VendorPause.campaign,
                    portfolio: VendorPause.portfolio,
                    servicer: VendorPause.servicer,
                    startDate: (VendorPause.startDate ? setDatePst(VendorPause.startDate) : 'N/A'),
                    expiration: (VendorPause.expiration ? setDatePst(VendorPause.expiration) : 'N/A'),
                    pauseSource: (VendorPause.pauseSource)
                }))}
                editable={{
                    isDeletable: rowData => tableRef.current ? tableRef.current.dataManager.data.filter(o => o.tableData.checked).length === 0 : false,
                    onRowAdd: newData =>
                        new Promise((resolve, reject) => {
                            setTimeout(() => {
                                const {servicer, portfolio, campaign, expiration, startDate} = newData;
                                const data = {
                                    servicer: hasServicer(servicer) ? servicer.servicer : servicer,
                                    portfolio,
                                    campaign,
                                    expiration: expiration ? expiration.toLocaleString() : null,
                                    startDate: startDate ? startDate.toLocaleString() : null,
                                };
                                if (!servicer && (!portfolio || !campaign)) {
                                    alert('Please fill out all required fields');
                                    reject();
                                } else {
                                    const finalData = _.omitBy(data, _.isNil)
                                    console.log(finalData)
                                    createVendorPause({
                                        variables: {
                                            input: {
                                                ...finalData
                                            }
                                        }
                                    });
                                    resolve();
                                }
                            }, 1000);
                        }),
                    onRowUpdate: env === 'test' ? (newData, oldData) =>
                        new Promise((resolve, reject) => {
                            setTimeout(() => {
                                const {servicer, portfolio, campaign, expiration, startDate} = newData;
                                const data = {
                                    id: oldData.id,
                                    expiration: expiration === "N/A" ? null : expiration.toLocaleString(),
                                    startDate: startDate === "N/A" ? null : startDate.toLocaleString(),
                                };

                                updateVendorPause({
                                    variables: {
                                        input: {
                                            ...data
                                        }
                                    }
                                });

                                resolve();
                            }, 1000);
                        }) : null,
                    onRowDelete: oldData =>
                        new Promise((resolve, reject) => {
                            setTimeout(() => {
                                deleteVendorPause({
                                    variables: {
                                        input: {
                                            id: oldData.id
                                        }
                                    }
                                });
                                resolve();
                            }, 1000)
                        }),
                }}
                actions={[
                    {
                        icon: () => <RefreshIcon/>,
                        tooltip: 'Refetch Data',
                        isFreeAction: true,
                        onClick: (event) => refetch()
                    }
                ]}
                options={{
                    addRowPosition: 'first',
                    pageSize: 100,
                    pageSizeOptions: [100, 200, 300],
                    headerStyle: {
                        minWidth: 'auto',
                    },
                    search: true,
                    selection: true,
                    selectionProps: (rowData) => ({
                        checked: rowData.tableData.checked || getChecked(rowData.id)

                    }),
                }}
                onSelectionChange={onSelectionChange}
            />
        </>
    )
})

export default VendorPauseTable